(() => {
  const slugify = (text) =>
    text
      .toLowerCase()
      .trim()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const initToc = (root) => {
    const content = root.querySelector('[data-article-content]');
    const lists = Array.from(root.querySelectorAll('[data-article-toc-list]'));
    if (!content || !lists.length) return;

    const headings = Array.from(content.querySelectorAll('h2')).filter(
      (heading) => heading.textContent.trim().length > 0
    );

    if (!headings.length) {
      root.querySelectorAll('.article-toc').forEach((toc) => {
        toc.hidden = true;
      });
      return;
    }

    const usedIds = new Set(
      Array.from(document.querySelectorAll('[id]'))
        .map((element) => element.id)
        .filter(Boolean)
    );

    headings.forEach((heading, index) => {
      let id = heading.id.trim();

      if (!id) {
        const base = slugify(heading.textContent) || `section-${index + 1}`;
        let candidate = base;
        let suffix = 2;

        while (usedIds.has(candidate)) {
          candidate = `${base}-${suffix}`;
          suffix += 1;
        }

        id = candidate;
        heading.id = id;
        usedIds.add(id);
      }
    });

    lists.forEach((list) => {
      list.textContent = '';

      headings.forEach((heading) => {
        const item = document.createElement('li');
        const link = document.createElement('a');

        link.className = 'article-toc__link';
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        link.dataset.tocTarget = heading.id;

        item.appendChild(link);
        list.appendChild(item);
      });
    });

    const links = Array.from(root.querySelectorAll('.article-toc__link'));

    const setActive = (id) => {
      links.forEach((link) => {
        const active = link.dataset.tocTarget === id;
        link.classList.toggle('is-active', active);
        if (active) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const updateActive = () => {
      const threshold = Math.min(window.innerHeight * 0.25, 180);
      let current = headings[0];

      headings.forEach((heading) => {
        if (heading.getBoundingClientRect().top <= threshold) {
          current = heading;
        }
      });

      setActive(current.id);
    };

    let ticking = false;
    const requestActiveUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        updateActive();
        ticking = false;
      });
    };

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.getElementById(link.dataset.tocTarget);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });

        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', `#${target.id}`);
        }

        const mobileDetails = link.closest('details');
        if (mobileDetails) mobileDetails.removeAttribute('open');

        setActive(target.id);
      });
    });

    window.addEventListener('scroll', requestActiveUpdate, { passive: true });
    window.addEventListener('resize', requestActiveUpdate, { passive: true });
    updateActive();

    if (window.location.hash) {
      const hashId = decodeURIComponent(window.location.hash.slice(1));
      const hashTarget = headings.find((heading) => heading.id === hashId);
      if (hashTarget) {
        window.requestAnimationFrame(() => {
          hashTarget.scrollIntoView({ block: 'start' });
        });
      }
    }
  };

  const init = () => {
    document.querySelectorAll('[data-article-toc-root]').forEach(initToc);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
